import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaCubes, FaChevronDown } from "react-icons/fa";

const navLinks = [
 
  { id: "industries", label: "Industries", hasDropdown: true },
  { id: "features", label: "Features" ,route: "/features"},
  { id: "pricing", label: "Pricing", route: "/pricing" },
   { id: "WhyAssetFlows", label: "Why AssetFlows?", route: "/why-assetflow" },
     { id: "blog", label: "Blog", route: "/blogs" },
  { id: "contact", label: "Contact", route: "/contact" },

];

const industries = [
  { name: "IT & Software", id: "it", icon: "" },
  { name: "Healthcare", id: "healthcare", icon: "" },
  { name: "Manufacturing", id: "manufacturing", icon: "" },
  { name: "Education", id: "education", icon: "" },
  { name: "Retail & E-commerce", id: "retail", icon: "" },
  { name: "Real Estate", id: "realestate", icon: "" },
  { name: "Transportation", id: "transportation", icon: "" },
  { name: "Logistics", id: "logistics", icon: "" },
  { name: "Government", id: "government", icon: "" },
  { name: "Energy & Utilities", id: "energy", icon: "" },
];

const Navbar = ({ activeSection = '', setActiveSection = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [industriesDropdownOpen, setIndustriesDropdownOpen] = useState(false);
  const [activeIndustry, setActiveIndustry] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (industriesDropdownOpen && !e.target.closest('.lp-nav__dropdown-container')) {
        setIndustriesDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [industriesDropdownOpen]);

  // Detect route changes and update active section
  useEffect(() => {
    const currentPath = location.pathname;
    const activeNav = navLinks.find(link => link.route === currentPath);
    if (activeNav) {
      setActiveSection(activeNav.id);
    }
  }, [location.pathname, setActiveSection]);

  const scrollTo = (id) => {
    setActiveSection(id);
    setMenuOpen(false);
    setIndustriesDropdownOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleNavigation = (route) => {
    setMenuOpen(false);
    setIndustriesDropdownOpen(false);
    navigate(route);
    // Scroll to top after navigation
    setTimeout(() => window.scrollTo(0, 0), 0);
  };

  const handleIndustriesClick = () => {
    setIndustriesDropdownOpen(!industriesDropdownOpen);
  };

  const handleIndustrySelect = (industry) => {
    setActiveIndustry(industry.id);
    setMenuOpen(false);
    setIndustriesDropdownOpen(false);
    navigate(`/industry/${industry.id}`);
    setTimeout(() => window.scrollTo(0, 0), 0);
  };

  return (
    <nav className={`lp-nav ${scrolled ? "lp-nav--scrolled" : ""}`}>
      <div className="lp-nav__inner">
        <div className="lp-nav__brand" onClick={() => handleNavigation("/")}>
          <FaCubes className="lp-nav__logo-icon" />
          <span>AssetFlows</span>
        </div>

        <ul className={`lp-nav__links ${menuOpen ? "open" : ""}`}>
          {navLinks.map((l) => (
            <li key={l.id} className={l.hasDropdown ? "lp-nav__item--dropdown" : ""}>
              {l.hasDropdown ? (
                <div className="lp-nav__dropdown-container">
                  <button
                    className={`lp-nav__link lp-nav__link--dropdown ${activeSection === l.id ? "active" : ""}`}
                    onClick={handleIndustriesClick}
                  >
                    {l.label}
                    <FaChevronDown className={`dropdown-icon ${industriesDropdownOpen ? "open" : ""}`} />
                  </button>
                  {industriesDropdownOpen && (
                    <div className="lp-nav__dropdown-menu">
                      <div className="lp-nav__dropdown-grid">
                        {industries.map((industry, idx) => (
                          <button
                            key={idx}
                            className={`lp-nav__dropdown-item ${activeIndustry === industry.id ? 'active' : ''}`}
                            onClick={() => handleIndustrySelect(industry)}
                          >
                            <span className="industry-icon">{industry.icon}</span>
                            <span className="industry-name">{industry.name}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <button
                  className={`lp-nav__link ${activeSection === l.id ? "active" : ""}`}
                  onClick={() => {
                    if (l.route) {
                      handleNavigation(l.route);
                    } else {
                      scrollTo(l.id);
                    }
                  }}
                >
                  {l.label}
                </button>
              )}
            </li>
          ))}
          <li className="lp-nav__cta-mobile">
            <button className="lp-btn lp-btn--sm" onClick={() => { navigate("/login"); setMenuOpen(false); }}>Login</button>
            <button className="lp-btn lp-btn--sm lp-btn--secondary" onClick={() => { navigate("/signup"); setMenuOpen(false); }}>Sign Up</button>
          </li>
        </ul>

        <div className="lp-nav__right">
          <button className="lp-btn lp-btn--sm" onClick={() => { navigate("/login"); }}>Login</button>
          <button className="lp-btn lp-btn--sm lp-btn--secondary" onClick={() => { navigate("/signup"); }}>Sign Up</button>
          <button className="lp-nav__hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
